import * as React from 'react';
import { Container, Form, Radio, Button } from 'semantic-ui-react';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Sentry from '@sentry/browser';
import { recaptchaSize } from '../../helpers/common';
import FormsPostcodeSearch from './FormsPostcodeSearch';
import { submitFormData } from '../../helpers/form-api';

const recaptchaKey = process.env.GATSBY_GOOGLE_RECAPTCHA_KEY || '';

class CompletionOfWorksForm extends React.Component {
  initialFormData = {
    network_distributor: '',
    first_name: '',
    last_name: '',
    phone: '',
    company: '',
    address: '',
    suburb: '',
    postcode: '',
    site_address: '',
    site_suburb: '',
    site_postcode: '',
    after_hours_phone: '',
    contact_fax: '',
    email: '',
    permit_no: '',
    date_of_permit: '',
  };

  state = {
    error: null,
    success: null,
    submitting: false,
    formData: { ...this.initialFormData },
  };

  recaptchaRef = React.createRef();

  handleCaptcha = (value) => {
    this.setState({ captcha: value });
  };

  handleInputChange = (event) => {
    const target = event.currentTarget;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  handleSelectChange = (event, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  handleSubmit = async () => {
    try {
      this.setState({ success: null, error: null, submitting: true });

      if (this.state.captcha) {
        const formData = {
          ...this.state.formData,
          captchaResponse: this.state.captcha,
        };
        const response = await submitFormData('completion_of_works', formData);

        if (response.status !== 200) {
          this.setState({
            success: null,
            error: response.message,
            submitting: false,
            captcha: null,
          });
        } else {
          this.setState({
            success: 'Success',
            error: null,
            submitting: false,
            formData: { ...this.initialFormData },
            captcha: null,
          });
        }

        if (this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
      } else {
        this.setState({
          success: null,
          error: 'Please tick ReCAPTCHA',
          submitting: false,
        });
      }
    } catch (err) {
      console.error(err);
      Sentry.captureException(err);
      this.setState({ error: 'Error', success: null, submitting: false });
    }
  };

  submitText = () => {
    if (this.state.submitting) {
      return 'Submitting...';
    } else if (this.state.success) {
      return 'Submitted';
    }
    return 'Submit';
  };

  render() {
    const {
      first_name,
      last_name,
      phone,
      company,
      address,
      suburb,
      postcode,
      site_address,
      site_suburb,
      site_postcode,
      after_hours_phone,
      contact_fax,
      email,
      permit_no,
      date_of_permit,
      network_distributor,
    } = this.state.formData;

    return (
      <section>
        <Container>
          <div className="grid-wrapper">
            <div className="form-container">
              <FormsPostcodeSearch />
              <Form onSubmit={this.handleSubmit}>
                <h4>Network distributor</h4>
                <Form.Field>
                  <p>
                    Did you complete your works within the CitiPower or Powercor
                    network?<span className="form-required">*</span>
                  </p>
                  <div className="form__radio-group">
                    <Radio
                      label="CitiPower network"
                      name="network_distributor"
                      checked={network_distributor === 'citipower'}
                      onChange={this.handleSelectChange}
                      value="citipower"
                      required
                      id="form-network-citipower"
                    />
                    <Radio
                      label="Powercor network"
                      name="network_distributor"
                      checked={network_distributor === 'powercor'}
                      onChange={this.handleSelectChange}
                      value="powercor"
                      id="form-network-powercor"
                    />
                  </div>
                </Form.Field>

                <h4>Your contact information</h4>
                <Form.Input
                  label="First name"
                  required
                  name="first_name"
                  type="text"
                  value={first_name}
                  onChange={this.handleInputChange}
                  id="form-first-name"
                />

                <Form.Input
                  label="Last name"
                  required
                  type="text"
                  name="last_name"
                  value={last_name}
                  onChange={this.handleInputChange}
                  id="form-last-name"
                />

                <Form.Input
                  label="Phone number"
                  required
                  type="text"
                  name="phone"
                  value={phone}
                  onChange={this.handleInputChange}
                  id="form-phone"
                />

                <Form.Input
                  label="Company name"
                  type="text"
                  name="company"
                  value={company}
                  onChange={this.handleInputChange}
                  id="form-company-name"
                />

                <Form.Input
                  label="Company Street address"
                  type="text"
                  name="address"
                  value={address}
                  onChange={this.handleInputChange}
                  id="form-address"
                />

                <Form.Field>
                  <Form.Input
                    label="Suburb"
                    type="text"
                    name="suburb"
                    value={suburb}
                    onChange={this.handleInputChange}
                    id="form-suburb"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Postcode"
                    type="text"
                    name="postcode"
                    value={postcode}
                    onChange={this.handleInputChange}
                    id="form-postcode"
                  />
                </Form.Field>

                <Form.Input
                  label="Site Street address"
                  required
                  type="text"
                  name="site_address"
                  value={site_address}
                  onChange={this.handleInputChange}
                  id="form-address"
                />

                <Form.Field>
                  <Form.Input
                    label="Site Suburb"
                    required
                    type="text"
                    name="site_suburb"
                    value={site_suburb}
                    onChange={this.handleInputChange}
                    id="form-site-suburb"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Site Postcode"
                    required
                    type="text"
                    name="site_postcode"
                    value={site_postcode}
                    onChange={this.handleInputChange}
                    id="form-site-postcode"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="After Hours Phone Number"
                    type="phone"
                    required
                    name="after_hours_phone"
                    value={after_hours_phone}
                    onChange={this.handleInputChange}
                    id="form-after-hours-phone"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Contact Fax"
                    type="phone"
                    name="contact_fax"
                    value={contact_fax}
                    onChange={this.handleInputChange}
                    id="form-contact-fax"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Email address"
                    required
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleInputChange}
                    id="form-email"
                  />
                </Form.Field>

                <h4>Permit Details</h4>
                <Form.Field>
                  <Form.Input
                    label="Permit Number"
                    type="text"
                    name="permit_no"
                    value={permit_no}
                    onChange={this.handleInputChange}
                    required
                    id="form-permit-no"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    className='calendar-icon'
                    label="Date of permit"
                    type="date"
                    name="date_of_permit"
                    value={date_of_permit}
                    onChange={this.handleInputChange}
                    required
                    id="form-date-of-permit"
                  />
                </Form.Field>

                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  sitekey={recaptchaKey}
                  onChange={this.handleCaptcha}
                  size={recaptchaSize()}
                />

                <Button
                  className="form--submit-btn"
                  disabled={this.state.submitting}
                  loading={this.state.submitting}
                >
                  {this.submitText()}
                </Button>

                {this.state.success ? (
                  <div className="success-message">{this.state.success}</div>
                ) : null}
                {this.state.error ? (
                  <div className="error-message">{this.state.error}</div>
                ) : null}
              </Form>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

export default CompletionOfWorksForm;
